import PropTypes from 'prop-types'
import React, {Component} from 'react'

export default class Swipeable extends Component {
  componentDidMount() {
    this.ref.addEventListener('mousedown', this.onStart)
    this.ref.addEventListener('touchstart', this.onStart)
    this.ref.addEventListener('mousemove', this.onMove)
    this.ref.addEventListener('touchmove', this.onMove)
    this.ref.addEventListener('mouseup', this.onEnd)
    this.ref.addEventListener('touchend', this.onEnd)
  }

  componentWillUnmount() {
    this.ref.removeEventListener('mousedown', this.onStart)
    this.ref.removeEventListener('touchstart', this.onStart)
    this.ref.removeEventListener('mousemove', this.onMove)
    this.ref.removeEventListener('touchmove', this.onMove)
    this.ref.removeEventListener('mouseup', this.onEnd)
    this.ref.removeEventListener('touchend', this.onEnd)
  }

  setRef = (ref) => {
    this.ref = ref
  }

  onStart = (e) => {
    this.startX = (e.touches ? e.touches[0] : e).clientX
    this.startY = (e.touches ? e.touches[0] : e).clientY
  }

  onMove = (e) => {
    if (!(this.startX && this.startY)) {
      return
    }

    this.endX = (e.touches ? e.touches[0] : e).clientX
    this.endY = (e.touches ? e.touches[0] : e).clientY
  }

  onEnd = (e) => {
    const {onSwipe, swipeSize} = this.props
    const swipe = {
      left: this.endX - this.startX > swipeSize,
      right: this.startX - this.endX > swipeSize,
      up: this.startY - this.endY > swipeSize,
      down: this.endY - this.startY > swipeSize
    }

    delete this.startX
    delete this.startY
    delete this.endX
    delete this.endY

    onSwipe && onSwipe(e, swipe)
  }

  render() {
    const {
      children,
      componentClass: Container,
      onSwipe, // eslint-disable-line no-unused-vars
      swipeSize, // eslint-disable-line no-unused-vars
      ...props
    } = this.props

    return (
      <Container ref={this.setRef} {...props}>
        {children}
      </Container>
    )
  }
}

Swipeable.propTypes = {
  children: PropTypes.any,
  componentClass: PropTypes.node,
  onSwipe: PropTypes.func,
  swipeSize: PropTypes.number
}

Swipeable.defaultProps = {
  componentClass: 'div',
  swipeSize: 30
}
